import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import { getDataApi1, loadApi, saveApi, loadApi1, saveApi1} from "../services/appApi";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const Client1099Divs  = () => {

  let emptyRow = {
    account_owner_code_desc: null,
    account_owner_code_mean: null,
    account_owner_lkcd: "",
    business_dba_name: null,
    business_email_address: null,
    business_federal_tax_id: null,
    business_legal_name: null,
    business_phone_number: null,
    client_1099_div_id: null,
    client_contact_cell_phone: null,
    client_contact_email_address: null,
    client_contact_home_phone: null,
    client_contact_work_phone: null,
    client_federal_tax_id: null,
    client_federal_tax_id_type: "",
    client_first_name: "",
    client_id: null,
    client_last_name: null,
    client_middle_name: null,
    client_type_desc: null,
    client_type_lkcd: "",
    client_type_mean: null,
    created_by: null,
    creation_date: "",
    description: null,
    firm_id: null,
    last_update_date: "",
    last_updated_by: null,
    ordinary_dividents: null,
    payer_name: "",
    qualified_dividents: null,
    spouse_contact_cell_phone: null,
    spouse_contact_email_address: null,
    spouse_contact_home_phone: null,
    spouse_contact_work_phone: null,
    spouse_federal_tax_id: null,
    spouse_federal_tax_id_type: "",
    spouse_first_name: null,
    spouse_last_name: null,
    spouse_middle_name: null,
    tax_year: null,
    tax_year_description: "",
    total_capgain_dist: null
    };

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [filters, setFilters] = useState({
      client_first_name: {value: null, matchMode: FilterMatchMode.IN,},
      tax_year: {value: null, matchMode: FilterMatchMode.IN,}
    });
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);
  const [currentMode, setCurrentMode] = useState(''); 
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [fetchClientFlag, setFetchClientFlag] = useState(false);
  const userId = localStorage.getItem("taxUserId");

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1(`/ztx_client_1099_divs_v/?offset=${offset}&limit=${limit}`);
        allData = [...allData, ...response.data.items];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
        }
        if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
            // Set the error message and display the dialog
            setIsLoading(false);
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };
    useEffect(() => {
          const fetchClient = async () => {
            setFetchClientFlag(true);
            try {
              let offset = 0;
              let limit = 25;
              let hasMore = true;
              let allData = [];
              let status = null;
              while (hasMore) {
                const response = await getDataApi1(
                  `/ztx_firm_clients_v/?offset=${offset}&limit=${limit}`,
                );
                allData = [...allData, ...response.data.items];
                status = response.status;
                hasMore = response.data.hasMore;
                offset = offset + limit;
              }
              if (allData.length > 0) {
                const options = allData.map((item) => ({
                  label: item.client_first_name,
                  value: item.client_id,
                }));
                setClientNameOptions(options);
                console.log(options);
                setFetchClientFlag(false);
              }
            } catch (err) {
              console.error(err);
              setFetchClientFlag(false);
            }
          };
          fetchClient();
        }, []);
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  const numOrdDivsTemplate = (rowData) => {
    return (rowData.ordinary_dividents || rowData.ordinary_dividents === 0) ? numeral(rowData.ordinary_dividents).format('0,0.00') : null;
  };
  const numQualDivsTemplate = (rowData) => {
    return (rowData.qualified_dividents || rowData.qualified_dividents === 0) ? numeral(rowData.qualified_dividents).format('0,0.00') : null;
  };
  const numTotCGDistsTemplate = (rowData) => {
    return (rowData.total_capgain_dist || rowData.total_capgain_dist === 0) ? numeral(rowData.total_capgain_dist).format('0,0.00') : null;
  };

  const numOrdDivs = (row.ordinary_dividents || row.ordinary_dividents === 0) ? numeral(row.ordinary_dividents).format('0,0.00') : null;
  const numQualDivs = (row.qualified_dividents || row.qualified_dividents === 0) ? numeral(row.qualified_dividents).format('0,0.00') : null;
  const numTotCGDists = (row.total_capgain_dist || row.total_capgain_dist === 0) ? numeral(row.total_capgain_dist).format('0,0.00') : null;
  
  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

  const showNewProduct = () => {
    setRow(emptyRow);
    setCurrentMode('I');
    setShowProductDialog(true);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setCurrentMode('R');
    setShowProductDialog(true);
}

const showEditProduct = (row) => {
    setRow({ ...row }); 
    setCurrentMode('U');
    setShowProductDialog(true);
  };

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">1099Divs Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      1099Divs
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}

      <Button
        // label="New"
        icon="pi pi-plus"
        className="p-button-success p-button-rounded p-mr-2"
        onClick={showNewProduct}
        tooltip="New"
        tooltipOptions={{ position: "bottom" }}
      />
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const editBodyTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-pencil"
            className="p-button-rounded p-button-secondary"
            onClick={() => showEditProduct(rowData)}
            tooltip="Edit"
            tooltipOptions={{ position: "bottom" }}
          />
        </React.Fragment>
      );
  };

  const clientOptions = [...new Set(rows.map((item) =>  item.client_first_name).filter(Boolean)),].map((client_first_name) => ({
    label: client_first_name, value: client_first_name,
  }));

  const taxYearOptions = [...new Set(rows.map((item) =>  item.tax_year).filter(Boolean)),].map((tax_year) => ({
    label: tax_year, value: tax_year,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={clientOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Client"
    display="chip" showClear/>
  )

  const taxYearFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={taxYearOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select"
    display="chip" showClear/>
  )

  const saveData = async (currentMode) => {
    if(currentMode === 'I') {
    try {
      const p_param = {
        p_user_id: userId,                                                                            
        p_client_id: row.client_id,                                                                
        p_tax_year: row.tax_year,                                                
        p_payer_name: row.payer_name,           
        p_account_owner_lkcd: row.account_owner_lkcd,                                                    
        p_ordinary_dividents: row.ordinary_dividents,                                               
        p_qualified_dividents: row.qualified_dividents,                                             
        p_total_capgain_dist: row.total_capgain_dist, 
        p_description: row.description
      };
      console.log("Insert p_param: ", p_param);
      const response = await loadApi1(
        p_param,
        "/ztx_client_1099_divs/v1/",
      );
      console.log(response);
      console.log(response.data);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Inserted",
        });
        const newRow = {
          client_w2_id: response.data.o_client_w2_id,
          ...row,
        };
        setRows((prev) => [...prev, newRow]);
        setShowProductDialog(false);
        setCurrentMode('');
        setRow(emptyRow);
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Inserted",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
        setErrorDialogVisible(true);
      }
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  } else if (currentMode === 'U'){

     const p_param = {                                                                              
	      p_user_id: userId,                                                                            
        p_client_id: row.client_id,   
        p_client_1099_div_id: row.client_1099_div_id,                                                               
        p_tax_year: row.tax_year,                                                
        p_payer_name: row.payer_name, 
        p_account_owner_lkcd: row.account_owner_lkcd,                                                               
        p_ordinary_dividents: row.ordinary_dividents,                                               
        p_qualified_dividents: row.qualified_dividents,                                             
        p_total_capgain_dist: row.total_capgain_dist,    
        p_description: row.description                                                                  
    
     };    
   
    console.log("Edit p_param: ", p_param);
    try {
      const response = await saveApi1(
        p_param,
        `/ztx_client_1099_divs/v1/`,
      );
      console.log(response);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Updated",
        });
        setRows((prev) =>
          prev.map((data) =>
            data.client_1099_div_id === row.client_1099_div_id
              ? { ...row }
              : data,
          ),
        );
        setShowProductDialog(false);
        setCurrentMode('');
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Updated",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
      }

      //setRows(response.data);
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  }
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">1099Divs</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="client_1099_div_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={taxPageRows}
          rowsPerPageOptions={taxRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          filters={filters}
          filterDisplay="row"
          onFilter={(e) => setFilters(e.filters)}
        > 

          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={editBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="client_first_name" header="Client" sortable filter showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} filterElement={clientFilterTemplate}></Column>
          <Column field="tax_year" header="Tax Year" filter showFilterMenu={false} filterElement={taxYearFilterTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="payer_name" header="Payer" sortable></Column>
          <Column field="ordinary_dividents" header="OrdDivs" body={numOrdDivsTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="qualified_dividents" header="QualDivs" body={numQualDivsTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="total_capgain_dist" header="TotCGDists" body={numTotCGDistsTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
        </DataTable>
      </div>
      )}

      {/* <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="1099Divs" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="tax_year">Tax Year</label>
                    <div className="box">
                        {row.tax_year}
                    </div>

                <label htmlFor="payer_name">Payer</label>
                    <div className="box">
                        {row.payer_name}
                    </div>

                <label htmlFor="ordinary_dividents">OrdDivs</label>
                    <div className="box">
                        {numOrdDivs}
                    </div>
                <label htmlFor="qualified_dividents">QualDivs</label>
                    <div className="box">
                        {numQualDivs}
                    </div>

                <label htmlFor="total_capgain_dist">TotCGDists</label>
                    <div className="box">
                        {numTotCGDists}
                    </div>


            </Dialog> */}

            <Dialog
              // header="Add 1099Divs"
              header={currentMode === 'I' ? "Add 1099Divs" : currentMode === 'U' ? "Update 1099Divs" : currentMode === 'R' ? "View 1099Divs" : "1099Divs"}
              visible={showproductDialog}
              style={{ width: "40rem" }}
              onHide={() => setShowProductDialog(false)}
            >
              <div className="p-fluid">
                <div className="grid">
                  <div className="col-12  field">
                    <label>Client</label>
                    <Dropdown
                      value={row.client_id}
                      disabled = {currentMode === 'R' ? true : false}
                      options={clientNameOptions}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select Client"
                      onChange={(e) => {
                        const selectedOption = clientNameOptions.find(
                          (option) => option.value === e.value,
                        );
                        setRow({
                          ...row,
                          client_id: e.value,
                          client_first_name: selectedOption?.label || "",
                        });
                      }}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>Tax Year</label>
                    <InputNumber
                      value={row.tax_year}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={false}
                      onChange={(e) => setRow({ ...row, tax_year: e.value })}
                    />
                  </div>
                  <div className="col-12  field">
                    <label>Payer</label>
                    <InputText
                      value={row.payer_name}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, payer_name: e.target.value })}
                    />
                  </div>

                  <div className="col-12  field">
                    <label>Account Owner Lkdc</label>
                    <InputText
                      value={row.account_owner_lkcd}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, account_owner_lkcd: e.target.value })}
                    />
                  </div>

                  <div className="col-12  field">
                    <label>Description </label>
                    <InputTextarea value={row.description} disabled = {currentMode === 'R' ? true : false} 
                      onChange={(e) => setRow({ ...row, description: e.target.value })} rows={5} cols={30}
                    />
                  </div>
                  
                  <div className="col-12  md:col-6  field">
                    <label>OrdDivs</label>
                    <InputNumber
                      value={row.ordinary_dividents}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, ordinary_dividents: e.value })}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>QualDivs</label>
                    <InputNumber
                      value={row.qualified_dividents}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, qualified_dividents: e.value })}
                    />
                  </div>
                  <div className="col-12 md:col-6 field">
                    <label>TotCGDists</label>
                    <InputNumber
                      value={row.total_capgain_dist}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={true}
                      mode="decimal"
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, total_capgain_dist: e.value })}
                    />
                  </div>
                </div>
                
                <div
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.5rem",
                  }}
                >
                  <Button
                    label="Cancel"
                    icon="pi pi-times"
                    severity="secondary"
                    onClick={() => {
                      setShowProductDialog(false);
                      setRow(emptyRow);
                      setCurrentMode('');
                    }}
                  />
                  <Button label="Save" icon="pi pi-check" onClick={(e) => saveData(currentMode)} />
                </div>
              </div>
            </Dialog>
            {!apiErrorDialog && (
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{width: '25rem'}} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            )}
            </div>
    </div>
  );
};

export default Client1099Divs;